import React from "react";
import { cardData } from "../../Data/ArticleData";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Footer from "../../Components/Footer";
import HomeIcon from '@mui/icons-material/Home';
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { ThemeProvider,createTheme } from "@mui/material";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,  
        sm: 600,
        md: 1080,  
        lg: 1280, 
      },
    },
    palette: {
      primary: {
        main: '#00897b',
        light: '#80cbc4',
        dark: '#00695c',
        contrastText: '#fff',
      },
    },
  });
function Article() {
  let pathName = window.location.pathname;
  let pathe = pathName.replace(/%20/g, " ");
  let path1 = pathe.split("/")[2];
  const decodedPath = decodeURIComponent(path1);

  // Find the current article based on the decoded path
  const currentArticles = cardData.find(
    (article) => decodeURIComponent(article.name) === decodedPath
  );

  // Check if an article was found
  if (currentArticles) {
    console.log(currentArticles.name); // Log the found article
  } else {
    console.log("Article not found");
  }

  console.log(path1);
  return (
       <ThemeProvider theme={customTheme}>
    <div className="article">
      <div className="articleHead">
        <h1>{currentArticles.name}</h1>
        <h6>{currentArticles.tag}</h6>
      <div> <a href="/"><HomeIcon fontSize="small"/> <h5>الرئيسية</h5></a>
     <KeyboardArrowLeftIcon/> <a href="/الخدمات"><h5>الخدمات</h5></a></div>
      </div>
      <div className="articleBody">
        <div className="articleBody1">
          <img
            src={require(`../../Images/programme/${currentArticles.icon}.jpg`)}
            alt={currentArticles.icon}
            className="articleBodyImg"
          />
 <h2>{currentArticles.name}</h2>

          <p
            className="articleDescreption"
            dangerouslySetInnerHTML={{ __html: currentArticles.description }}
          />
           <h4> {currentArticles.pricePromo ? (
                      <span
                        className="priceSpanArticle"
                        style={{
                          textDecoration: "line-through",
                          color: "#151a5b",
                        }}
                      >
                        &nbsp;{currentArticles.pricePromo} <span>ريال</span>
                      </span>
                    ) : (
                      <></>
                    )}
                    <span className="priceSpanArticle">
                      {" "}
                      &nbsp;{currentArticles.price} <span>ريال</span>{" "}
                    </span></h4>
                    <a href="whatsapp://send?phone=+966550769152">
                    <Button
                      startIcon={<WhatsAppIcon />}
                      sx={{ marginTop: "40px",marginBottom:'10px' }}
                      variant="contained"
                      color="primary"
                      size='large'
                    >
                   إحجز الآن
                    </Button>
                  </a>
        </div>
        <div className="articleBody2">
          <h3>: خدمات مماثلة </h3>
          <br />
          {cardData.map((card, index) =>
            card.tag === currentArticles.tag &&
            currentArticles.name !== card.name ? (
              <a href={`/الخدمات/${card.name}`} className="cardLink">
                <div key={index}>
                  {" "}
                  <Card variant="outlined" className="ArticelCard">
                    <CardMedia
                      component="img"
                      alt={card.title}
                      src={require(`../../Images/programme/${card.icon}.jpg`)}
                      className="card-media"
                    />
                    <CardContent style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                      <h3 className="articelCardTitle">
                        {card.name} | {card.tag}
                      </h3>
                      <h3 gutterBottom className="articelCardTitle">
                          
                      </h3>
                      <a href={`/الخدمات/${card.name}`}>
                    <Button
                      endIcon={<ArrowRightAltIcon />}
                      sx={{ marginTop: "20px" }}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      أكثر تفاصيل
                    </Button>
                  </a>
                    </CardContent>
                  </Card>{" "}
                </div>
              </a>
            ) : (
              <></>
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
    </ThemeProvider>
  );
}

export default Article;
